import { ReactElement, useState, useCallback, useEffect } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { ConfirmModal, GoBackButton, Button } from '~/components';
import { useLoading } from '~/hooks/loading';
import { ICoupon } from '~/models/Coupon';
import { CouponService } from '~/services';

import * as S from './styles';

interface ICouponDetailsParams {
  couponId: string;
}

function CouponsDetails(): ReactElement {
  const { setLoading } = useLoading();

  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [coupon, setCoupon] = useState<ICoupon>();
  const router = useHistory();
  const { couponId } = useParams<ICouponDetailsParams>();

  const handleOpenConfirmDeleteModal = useCallback(() => {
    setConfirmDeleteModal(true);
  }, []);

  const handleNavigateToEditCoupon = useCallback(() => {
    router.push(`/coupons/edit/${couponId}`);
  }, [couponId, router]);

  const handleDeleteCuponSubmit = useCallback(() => {
    toast.success('Cupom deletado.');
    router.goBack();
  }, [router]);

  const handleGetCoupon = useCallback(() => {
    setLoading(true);

    const response = CouponService.getAllCoupons();

    setCoupon(response.data?.find((i) => i.id === couponId));

    setLoading(false);
  }, [couponId]);

  useEffect(() => {
    handleGetCoupon();
  }, [handleGetCoupon]);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Detalhes do Cupom</S.Title>
        </S.Header>
        <S.InfosContainer>
          <S.InfosItem>
            <S.InfosItemTitle>Código</S.InfosItemTitle>
            <S.InfosItemValue>{coupon?.code}</S.InfosItemValue>
          </S.InfosItem>
          <S.InfosItem>
            <S.InfosItemTitle>Código</S.InfosItemTitle>
            <S.InfosItemValue>{coupon?.type}</S.InfosItemValue>
          </S.InfosItem>
          <S.InfosItem>
            <S.InfosItemTitle>Código</S.InfosItemTitle>
            <S.InfosItemValue>{coupon?.value}</S.InfosItemValue>
          </S.InfosItem>
          <S.InfosItem>
            <S.InfosItemTitle>Código</S.InfosItemTitle>
            <S.InfosItemValue>{coupon?.validity}</S.InfosItemValue>
          </S.InfosItem>
        </S.InfosContainer>
        <S.Footer>
          <Button
            variant="black"
            textContent="Editar"
            onClick={handleNavigateToEditCoupon}
            size="small"
            extraStyles={{
              maxWidth: '20rem',
              maxHeight: '3.5rem',
            }}
          />
          <Button
            variant="red"
            textContent="Excluir"
            onClick={handleOpenConfirmDeleteModal}
            size="small"
            extraStyles={{
              maxWidth: '20rem',
              maxHeight: '3.5rem',
            }}
          />
        </S.Footer>
      </S.Container>
      <ConfirmModal
        modalIsVisible={confirmDeleteModal}
        setModalIsVisible={setConfirmDeleteModal}
        title="Deletar cupom"
        textContent="Tem certeza que deseja deletar o cupom?"
        handleSubmit={handleDeleteCuponSubmit}
      />
    </>
  );
}

export default CouponsDetails;
